import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import 'src/components/SeeAllTile.scss';

import ChevronDoubleRight from '@mdi/svg/svg/chevron-double-right.svg';


class SeeAllTile extends PureComponent {
  render() {
    const { link, title, children } = this.props;

    return (
      <a data-test="anchor-seeAll" href={ link } styleName="see-all" title={ title }>

        <div styleName="see-all__icon">
          <ChevronDoubleRight viewBox="0 0 24 24" />
        </div>

        <p styleName="see-all__copy">{children}</p>

      </a>
    );
  }
}

SeeAllTile.propTypes = {
  children: PropTypes.node.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};


export default SeeAllTile;
